import React from 'react'

import { Stack } from '@mui/material'

import { ShortcutsCard } from './ShortcutsCard'

/**
 * Settings → Personal → Controls.
 *
 * Named "Controls", not "Keyboard shortcuts", following Vergence's
 * `/settings/controls`. The broader name is the durable one: this page is the
 * home for how the app RESPONDS to you — shortcuts today, and whatever comes
 * next (pointer behaviour, confirmation prompts, motion) without a rename that
 * breaks the route and everyone's muscle memory. Naming a page after its first
 * occupant is how you end up with "Keyboard shortcuts" containing three things
 * that are not keyboard shortcuts.
 *
 * The section heading INSIDE the page stays "Keyboard shortcuts" so the content
 * is self-describing on arrival — the nav label says where you are, the card
 * heading says what this is.
 *
 * Theme deliberately does NOT move here. It is an appearance preference, not a
 * control, and it already has a home on General.
 *
 * A page of its own rather than a card on General because the shortcuts dialog
 * links here: an anchor into the middle of a long General page lands the user
 * somewhere they have to hunt, while a route lands them exactly on the thing
 * they clicked through for.
 */
export const ControlsPage = () => (
  // 32px, matching Profile. Only one card today so this is currently invisible; set now so the
  // second card added here is spaced correctly by default rather than inheriting 16px.
  <Stack spacing={8}>
    <Stack>
      <ShortcutsCard />
    </Stack>
  </Stack>
)

